import { BUTTON, BUTTON_ICON, CLASS_MODIFIERS, ICON_BUTTON, LINK, CODE } from '../constants';
import COMPONENTS_DEFAULT_VALUES from '../constants/componentsDefaultValues';

const {
  BUTTON_TYPE,
  DEFAULT,
  DESKTOP,
  GTM_CLASS_NAME,
  HIDE,
  ICON,
  MOBILE,
  MODIFIER,
  SIZE,
  STICKY,
  STYLE,
  TABLET,
  WIDTH,
  ALIGNMENT,
  PARALLAX
} = CLASS_MODIFIERS;
const commonProps = [GTM_CLASS_NAME, MODIFIER, PARALLAX];
const responsiveProps = [DESKTOP, TABLET, MOBILE];
const buttonProps = [SIZE, BUTTON_TYPE, ICON, STYLE, ALIGNMENT, ...commonProps];
const iconProps = [BUTTON_TYPE, ...commonProps];

const commonAttributes = { props: commonProps, prefix: null };

const supportedTypes = {
  row: { props: [WIDTH, STICKY, ...responsiveProps, ...commonProps] },
  column: { props: [WIDTH, STICKY, ...responsiveProps, ...commonProps] },
  button: {
    props: buttonProps,
    prefix: BUTTON
  },
  icon: { props: iconProps, prefix: ICON_BUTTON },
  textBlock: { ...commonAttributes },
  banner: { ...commonAttributes },
  image: { ...commonAttributes },
  hero: { ...commonAttributes },
  video: { ...commonAttributes },
  list: { ...commonAttributes },
  code: { ...commonAttributes, prefix: CODE }
};

export default function getClassModifiers(type, props) {
  const { props: supportedProps, prefix } = supportedTypes[type] || {};
  const defaultValues = COMPONENTS_DEFAULT_VALUES[type] || {};
  if (!supportedProps) return '';

  const modifiers = supportedProps
    .map(prop => {
      const propValue = props[prop];
      const stringValue = typeof propValue === 'boolean' ? prop : propValue;

      const isResponsiveProp = responsiveProps.includes(prop);
      if (prop === ICON) return propValue ? BUTTON_ICON : '';
      if (prop === MODIFIER && propValue) return `${propValue}`;
      if (propValue === DEFAULT || stringValue === type) return '';
      if (isResponsiveProp) return propValue ? '' : `${HIDE}-${prop}`;
      if (propValue === null || propValue === undefined) return defaultValues[prop] || '';
      if (prop === WIDTH || prop === LINK) return `${type}--${propValue}`;
      if (prop === GTM_CLASS_NAME) return `${propValue}`;
      if (prop === STICKY) return propValue ? `${type}--${stringValue}` : '';
      if (prop === PARALLAX) return propValue ? `${type}--${stringValue}` : '';

      return stringValue ? `${type}--${stringValue}` : '';
    })
    .filter(Boolean);
  if (prefix) modifiers.unshift(prefix);

  return modifiers.join(' ');
}
